import colors from '@/helpers/colors';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { Scenario } from '@/dto/scenario/Scenario';

function getBarColor(successState: any) {
  if (successState === false) {
    return colors.red;
  }
  if (successState === true) {
    return colors.green;
  }
  return colors.blue;
}

function getConfiguration(scenario: ScenarioExt): string | null {
  const dto = scenario as Scenario; // NB : this works only because the two classes ScenarioExt and Scenario are correctly mapped.
  return Scenario.getConfiguration(dto);
}

const validConfigurations: string[] = [
  'configuration_off_grid_self_consumption_genset',
  // 'configuration_off_grid_self_consumption_battery',
  'configuration_off_grid_self_consumption_battery_genset',
  'configuration_bad_grid_self_consumption_grid_genset',
  'configuration_bad_grid_self_consumption_grid_genset_backup',
  // 'configuration_bad_grid_self_consumption_grid_battery',
  'configuration_bad_grid_self_consumption_grid_battery_genset',
  'configuration_self_consumption_without_injection_grid_24',
  'configuration_self_consumption_without_injection_grid_24_battery',
  'configuration_self_consumption_with_injection_grid_24_injection',
  'configuration_net_metering_grid_24_injection',
  'configuration_total_injection_grid_24_injection'
];

const errorsTranslation: any = {
  configuration_off_grid_self_consumption_battery: 'scenario.wizard.off_grid_battery_message',
  configuration_bad_grid_self_consumption_grid_battery: 'scenario.wizard.bad_grid_battery_message'
};

const scenarioHelper = {
  getBarColor,
  getConfiguration,
  validConfigurations,
  errorsTranslation
};

export default scenarioHelper;
